var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickWhiteGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_60)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.5,
    r: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78025 12.2802C8.634 12.4265 8.442 12.5 8.25 12.5C8.058 12.5 7.866 12.4265 7.71975 12.2802L4.71975 9.28025C4.4265 8.987 4.4265 8.513 4.71975 8.21975C5.013 7.9265 5.487 7.9265 5.78025 8.21975L8.25 10.6895L14.5125 4.427C13.1423 2.93825 11.1833 2 9 2C4.85775 2 1.5 5.35775 1.5 9.5C1.5 13.6423 4.85775 17 9 17C13.1423 17 16.5 13.6423 16.5 9.5C16.5 8.08625 16.1018 6.7685 15.4215 5.639L8.78025 12.2802Z",
    fill: "#08BD80"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickWhiteGreen);
export default __webpack_public_path__ + "static/media/tick_white_green.eea02362b82ea36850b5d87bbd46f7bf.svg";
export { ForwardRef as ReactComponent };